import { useEffect, useRef } from 'react';

export const useStableRowCount = (total) => {
  const prevTotalRef = useRef(total || -1);
  useEffect(() => {
    if (total !== undefined && total !== null) {
      prevTotalRef.current = total;
    }
  }, [total]);
  return total ?? prevTotalRef.current;
};
